import React, { useEffect, useState } from 'react';
import { GeoJSON } from 'react-leaflet';
import { getGeometryLayerRequestPath } from '../../config/geometry-layer-urls';
import { useDisplayPreferences } from '../../displayPreferences-context';
import { apiGet } from '../../apiHelpers';
export function BoroughBoundaryLayer({}) {
    const [boundaryGeojson, setBoundaryGeojson] = useState(null);
    const { borough } = useDisplayPreferences();
    useEffect(() => {
        apiGet(getGeometryLayerRequestPath('borough'))
            .then(data => {
            if (data && data.type === 'FeatureCollection') {
                setBoundaryGeojson(data);
            }
            else {
                setBoundaryGeojson(null);
            }
        })
            .catch(() => setBoundaryGeojson(null));
    }, []);
    if (borough == "enabled") {
        return boundaryGeojson &&
            React.createElement(GeoJSON, { attribution: 'Borough boundary from <a href=https://data.london.gov.uk/dataset/london_boroughs>London Datastore</a> Ordnance Survey Open Data - Contains public sector information licensed under the <a href=https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/>Open Government Licence v3.0</a>', data: boundaryGeojson, style: { color: '#f00', fill: false, weight: 1 } });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
